import { useEffect } from "react";
import { LOGIN_URL } from "../api/client";
import { useHealth } from "../hooks/useApi";
import { AntarcticaMark } from "./AntarcticaMark";

/**
 * No "sign in" button to click through - anyone not authenticated is sent straight
 * to /api/auth/login (which itself redirects to Authentik, or logs in the fixed dev
 * user when DEV_AUTH_BYPASS is on). The fallback link covers the rare case the
 * automatic redirect doesn't fire (JS disabled, popup/redirect blocker, etc.).
 */
export function LoginScreen() {
  const { data: health } = useHealth();
  const bypass = health?.devAuthBypass === true;

  useEffect(() => {
    window.location.href = LOGIN_URL;
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-6 text-center">
      <div className="flex items-center gap-3">
        <AntarcticaMark className="h-9 w-9 text-black dark:text-white" />
        <h1 className="text-3xl font-semibold tracking-tight">Hudson</h1>
      </div>
      <p className="text-sm text-slate-500 dark:text-night-400">
        Redirecting to sign in…{" "}
        <a href={LOGIN_URL} className="text-brand-600 underline hover:no-underline dark:text-brand-400">
          Click here
        </a>{" "}
        if nothing happens.
      </p>
      {bypass && (
        <p className="max-w-sm rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-800 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-300">
          DEV_AUTH_BYPASS is enabled — this skips Authentik and logs anyone in as a fixed local user. For
          local testing only.
        </p>
      )}
    </div>
  );
}
